import {
  MaterialsFormFieldsLabels,
  MaterialsFormFieldsTypes,
} from "../forms/forms-fields/materials-form-fields";

export enum EventType {
  DIGITAL = "DIGITAL",
  IN_PERSON = "IN-PERSON",
  BOTH = "BOTH",
}

export interface EventMaterial {
  Name: string;
}

export enum EventSubscriptionMethod {
  DIGITAL_SUBSCRIPTION = 0,
  IN_PERSON_SUBSCRIPTION = 1,
}

export enum EventSubscriptionType {
  OPEN_SUBSCRIPTION = 0,
  CLOSED_SUBSCRIPTION = 1,
}

export interface EventAllowedSubscription {
  soldOut: boolean;
  subscribeUrl: string;
  subscriptionMethod: EventSubscriptionMethod;
  subscriptionType: EventSubscriptionType;
  title: string;
}

export interface Event {
  id: number;
  startDateEvent: string;
  endDateEvent: string;
  startDateSubscription: string;
  endDateSubscription: string;
  title: string;
  materials: EventMaterial[];
  location: string;
  country: string;
  eventDescription: string;
  eventType: EventType;
  url: string;
  urlImg: string;
  videoContent: boolean;
  subscriptionTypes: EventAllowedSubscription[];
}

export enum EventsTimeInterval {
  PAST_EVENTS = "past-events",
  FUTURE_EVENTS = "future-events",
}

export type EventsTypeFilterValue = Record<EventType.DIGITAL | EventType.IN_PERSON, boolean>;

export interface EventsFiltersForm extends MaterialsFormFieldsTypes {
  timeInterval: EventsTimeInterval;
  eventType: EventsTypeFilterValue;
  search: string;
  country: string;
}

export interface PersonData {
  FirstName: string;
  LastName: string;
  Company: string;
}

export interface EventSubscription {
  id: number;
  eventId: number;
  urlSubscription: string;
  title: string;
  eventType: EventType;
  startDate: string;
  endDate: string;
  registrationConfirmed: boolean;
  registrationCancelled: boolean;
  materials: string[];
  paidEvent: boolean;
  subscriptionMethod: EventSubscriptionMethod;
  hotel: boolean;
  hotelDescription: string;
  rooms: string;
  checkInDate: string;
  checkOutDate: string;
  people: PersonData[];
}

export type EventsLabels = {
  "event-sold-out": string | null;
  "event-detail-fetch-error": string | null;
  "events-fetch-error": string | null;
  "events-no-results": string | null;
  "events-filters-country": string | null;
  "events-filters-all-countries": string | null;
  "event-type": string | null;
  "event-type-in-presence": string | null;
  "event-type-online": string | null;
  "event-go-to-details": string | null;
  "event-location": string | null;
  "event-description": string | null;
  "event-subscribe-cta-both": string | null;
  "event-subscribe-cta-online": string | null;
  "event-subscribe-cta-in-presence": string | null;
  "event-participate-cta-both": string | null;
  "event-participate-cta-online": string | null;
  "event-participate-cta-in-presence": string | null;
  "event-subscribe-button": string | null;
  "event-subscribe-modal-title": string | null;
  "event-subscribe-in-presence-button": string | null;
  "event-subscribe-online-button": string | null;
  "event-already-subscribed-question": string | null;
  "event-already-subscribed-logged": string | null;
  "event-past-relive-with-video": string | null;
  "event-past-relive-without-video": string | null;
  "event-past-relive-header": string | null;
  "event-past-relive-cta": string | null;
  "event-sign-in": string | null;
  "event-go-to-agenda": string | null;
  "event-subscriptions-open": string | null;
  "event-subscriptions-closed": string | null;
  "event-subscription-sold-out": string | null;
  "events-filters-toggle-button": string | null;
  "events-filters-submit-button": string | null;
  "events-filters-clear-button": string | null;
  "events-filters-materials": string | null;
  "events-filters-search": string | null;
  "events-filters-show-past": string | null;
  "events-filters-show-current-future": string | null;
  "events-load-more": string | null;
  "common-countdown-days": string | null;
  "common-countdown-hours": string | null;
  "common-countdown-minutes": string | null;
  "common-countdown-seconds": string | null;
} & MaterialsFormFieldsLabels;
